module.exports = __webpack_public_path__ + "img/success.f00f0108.png";